import React from 'react'
import '../Language.css';
function LanguagesScreen() {
    return (
        <div className="main-container">

        <h2>Languages</h2>
        <div className="image-container">


       
     <div className="whole-card">
      <div className="gray-card"></div>
        <div className="language">
           <div className="mid-container">
            <img src="https://secure-media0.hotstar.com/r1/languages/PCTV-hindi.svg" alt=""/>
            <span>Hindi</span>
            </div>
        </div>
     </div>
     <div className="whole-card">
     
      <div className="gray-card"></div>
        <div className="language" style={{ backgroundImage : `url('https://img1.hotstarext.com/image/upload/f_auto,t_web_hs_3x/sources/r1/cms/prod/old_images/LANGUAGE/5708/5708/5708-h')` }}>
           <div className="mid-container">
            <img src="https://secure-media2.hotstar.com/r1/languages/PCTV-bengali.svg" alt=""/>
            <span>Bengali</span>
            </div>
        </div>
     </div>
     <div className="whole-card">
      <div className="gray-card"></div>
        <div className="language" style={{ backgroundImage : `url('https://img1.hotstarext.com/image/upload/f_auto,t_web_hs_3x/sources/r1/cms/prod/old_images/LANGUAGE/5714/5714/5714-h')`}}>
           <div className="mid-container">
            <img src="https://secure-media2.hotstar.com/r1/languages/PCTV-telugu.svg" alt=""/>
            <span>Telugu</span>
            </div>
        </div>
     </div>
     <div className="whole-card">
      <div className="gray-card"></div>
        <div className="language" style={{ backgroundImage : `url('https://img1.hotstarext.com/image/upload/f_auto,t_web_hs_3x/sources/r1/cms/prod/old_images/LANGUAGE/5712/5712/5712-h')`}}>
           <div className="mid-container">
            <img src="https://secure-media1.hotstar.com/r1/languages/PCTV-malayalam.svg" alt=""/>
            <span>Malayalam</span>
            </div>
        </div>
     </div>
     <div className="whole-card">
      <div className="gray-card"></div>
        <div className="language" style={{ backgroundImage : `url('https://img1.hotstarext.com/image/upload/f_auto,t_web_hs_3x/sources/r1/cms/prod/9021/549021-h')`}}>
           <div className="mid-container">
            <img src="https://secure-media1.hotstar.com/r1/languages/PCTV-tamil.svg" alt=""/>
            <span>Tamil</span>
            </div>
        </div>
     </div>
     <div className="whole-card">
      <div className="gray-card"></div>
        <div className="language" style={{ backgroundImage : `url('https://img1.hotstarext.com/image/upload/f_auto,t_web_hs_3x/sources/r1/cms/prod/old_images/LANGUAGE/5715/5715/5715-h')`}}>
           <div className="mid-container">
            <img src="https://secure-media2.hotstar.com/r1/languages/PCTV-marathi.svg" alt=""/>
            <span>Matathi</span>
            </div>
        </div>
     </div>
     <div className="whole-card">
      <div className="gray-card"></div>
        <div className="language" style={{ backgroundImage : `url('https://img1.hotstarext.com/image/upload/f_auto,t_web_hs_3x/sources/r1/cms/prod/old_images/LANGUAGE/5709/5709/5709-h')`}}>
           <div className="mid-container">
            <img src="https://secure-media2.hotstar.com/r1/languages/PCTV-english.svg" alt=""/>
            <span>English</span>
            </div>
        </div>
     </div>
     <div className="whole-card lastLanguage-card">
      <div className="gray-card"></div>
        <div className="language" style={{ backgroundImage : `url('https://img1.hotstarext.com/image/upload/f_auto,t_web_hs_3x/sources/r1/cms/prod/old_images/LANGUAGE/5711/5711/5711-h')`}}>
           <div className="mid-container">
            <img src="https://secure-media0.hotstar.com/r1/languages/PCTV-kannada.svg" alt=""/>
            <span>Kannada</span>
            </div>
        </div>
     </div>
      
    

        </div>
    </div>
    )
}

export default LanguagesScreen
